import { vitaleDataType }                                   from "dmpconnectjsapp-base/helpers/vitaleData";
import PropTypes                                            from "prop-types";
import React                                                from "react";
import { dmpStatuses }                                      from "../../dmpconnect/constants";
import { getFullName }                                      from "../../dmpconnect/helpers/accessibleDMPList";
import { getSexFromIns }                                    from "../../dmpconnect/helpers/insi";
import { getQualifiedIns as getQualifiedInsFromVitaleCard } from "../../dmpconnect/helpers/vitaleCard";
import INSiIdentityProvider                                 from "../CertifiiedIdentity/INSiIdentityProvider";
import VitaleCardDate                                       from "../Common/Date/VitaleCardDate";
import SimpleTable                                          from "../Common/Table/SimpleTable";
import DMPStatusActions                                     from "../DMPStatus/DMPStatusActions";
import DMPStatusExtraActions                                from "../DMPStatus/DMPStatusExtraActions";
import DMPStatusProvider                                    from "../DMPStatus/DMPStatusProvider";

function StatusIcon ({
  // eslint-disable-next-line react/prop-types
  status, handleClick, ins, value
}) {
  return (
    <>
      {status === dmpStatuses.DMPExist ? (
        <button
          type="button"
          className="btn btn-link btn-sm typography-big-text-title"
          // eslint-disable-next-line react/prop-types
          onClick={() => handleClick(ins)}
        >
          {value}
        </button>
      ) : (
        <span className="typography-big-text-title">{value}</span>
      )}
    </>
  );
}

const vitaleDataPatientToInsPatient = vitaleDataPatient => ({
  // {
  //   "i_birthRank": 1,
  //   "i_quality": 0,
  //   "s_birthday": "19671114",
  //   "s_birthdayYYYYMMDD": "19671114",
  //   "s_rawBirthdayYYYYMMDD": "19671114",
  //   "s_birthname": "INSFAMILLEQUATRE",
  //   "s_certifiedNir": "1671126221704 59",
  //   "s_given": "ARTHUR",
  //   "s_name": "INSFAMILLEQUATRE",
  //   "s_nir": "1671126221704 59",
  //   "i_sex": 2
  // },
  name    : (vitaleDataPatient.s_birthname || vitaleDataPatient.s_name || '').trim(),
  given   : (vitaleDataPatient.s_given || '').trim(),
  birthday: vitaleDataPatient.s_birthdayYYYYMMDD,
  sex     : vitaleDataPatient.i_sex ? vitaleDataPatient.i_sex : getSexFromIns(vitaleDataPatient.s_certifiedNir || vitaleDataPatient.s_nir)
});

const getColumns = (
  accessRights,
  selector,
  vitaleCardStatus,
  handleClick,
  aldActive,
  showUploadForm,
  dataType,
  mssActive,
  regulationMode,
  aatActive,
  imtiActive,
  forceSynchronous = false
) => {
  let columns = [
    {
      Header  : "Patient",
      id      : "patientName",
      accessor: d => getFullName(d.s_name, d.s_given, d.s_birthname),
      // eslint-disable-next-line react/prop-types
      Cell: ({ row, value }) => {
        const qualifiedInsFromVitaleCard = getQualifiedInsFromVitaleCard(row.original.s_nir,
          vitaleCardStatus);
        // eslint-disable-next-line react/prop-types
        const apiSubSection              = `${qualifiedInsFromVitaleCard}_${row.index}`;
        return (
          <>
            {selector ? (
              <INSiIdentityProvider
                key={apiSubSection}
                // eslint-disable-next-line react/prop-types
                vitaleIndex={row.index}
                insFromVitaleCard={qualifiedInsFromVitaleCard}
                runOnMount={false}
                showLoading={false}
              >
                <DMPStatusProvider getOnMount={false} showLoading={false}>
                  <StatusIcon handleClick={handleClick} value={value} />
                </DMPStatusProvider>
              </INSiIdentityProvider>
            ) : (
              <span className="typography-big-text-title">{value}</span>
            )}
          </>
        );
      }
    },
    {
      Header  : "Né(e) le",
      id      : "s_birthday",
      accessor: "s_birthday",
      // eslint-disable-next-line react/prop-types
      Cell: ({ row, value }) => (
        <VitaleCardDate
          vitaleCardDate={value}
          // eslint-disable-next-line react/prop-types
          formattedVitaleCardDateYYYYMMDD={row.original.s_birthdayYYYYMMDD}
          className="typography-default-text-title"
        />
      )
    },
    {
      id    : "dmp-access",
      Header: selector ? "Statut" : "Accès au dossier patient",
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => {
        // eslint-disable-next-line react/prop-types
        const qualifiedInsFromVitaleCard = getQualifiedInsFromVitaleCard(row.original.s_nir,
          vitaleCardStatus);
        // eslint-disable-next-line react/prop-types
        const apiSubSection              = `${qualifiedInsFromVitaleCard}_${row.index}`;
        return (
          <INSiIdentityProvider
            key={`dmp-insi-${apiSubSection}`}
            subSection={apiSubSection}
            // forcer la recherche par trait si carte virtuelle
            vitaleIndex={row.index}
            insFromVitaleCard={qualifiedInsFromVitaleCard}
            ins2Patient={dataType === vitaleDataType.APCV_CONTEXT || row.original.virtualCard ? (
              vitaleDataPatientToInsPatient(row.original)
            ) : undefined}
            runOnMount
            showLoading
            forceSynchronous={forceSynchronous}
          >
            <DMPStatusProvider getOnMount>
              <DMPStatusActions
                accessDMP={ins => handleClick(ins, apiSubSection)}
                // aldActive={aldActive}
                // aatActive={aatActive}
                tlsSubSection={apiSubSection}
                regulationMode={regulationMode}
                vitalePatient={row.original}
                patientInfos={vitaleDataPatientToInsPatient(row.original)}
              />
            </DMPStatusProvider>
          </INSiIdentityProvider>
        );
      }
    },
    {
      id    : "actions",
      Header: "Actions",
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => {
        // eslint-disable-next-line react/prop-types
        const qualifiedInsFromVitaleCard = getQualifiedInsFromVitaleCard(row.original.s_nir,
          vitaleCardStatus);
        // eslint-disable-next-line react/prop-types
        const apiSubSection              = `${qualifiedInsFromVitaleCard}_${row.index}`;
        return (
          <INSiIdentityProvider
            key={`actions-insi-${apiSubSection}`}
            subSection={apiSubSection}
            // forcer la recherche par trait si carte virtuelle
            vitaleIndex={row.index}
            insFromVitaleCard={qualifiedInsFromVitaleCard}
            ins2Patient={dataType === vitaleDataType.APCV_CONTEXT || row.original.virtualCard ? (
              vitaleDataPatientToInsPatient(row.original)
            ) : undefined}
            runOnMount={false}
            showLoading
          >
            <DMPStatusProvider getOnMount={false} showError={false}>
              <DMPStatusExtraActions
                showUploadForm={ins => showUploadForm([], ins)}
                mssActive={mssActive}
                vitalePatient={row.original}
                imtiActive={imtiActive}
                aldActive={aldActive}
                aatActive={aatActive}
                tlsSubSection={apiSubSection}
              />
            </DMPStatusProvider>
          </INSiIdentityProvider>
        );
      }
    }
  ];
  
  if (selector) {
    columns = columns.filter(c => !["actions", "dmp-access"].includes(c.id));
  }
  return columns;
};

const VitaleCardPatients = ({
  vitaleCardStatus,
  patients,
  handleClick,
  aldActive,
  showUploadForm,
  selector,
  accessRights,
  dataType,
  mssActive,
  regulationMode,
  aatActive,
  imtiActive
}) => {
  const columns = React.useMemo(() => getColumns(
    accessRights,
    selector,
    vitaleCardStatus,
    handleClick,
    aldActive,
    showUploadForm,
    dataType,
    mssActive,
    regulationMode,
    aatActive,
    imtiActive,
    patients.length > 10
  ), []);
  return (
    <>
      <SimpleTable columns={columns} data={patients} striped />
    </>
  );
};

VitaleCardPatients.defaultProps = {
  vitaleCardStatus: null,
  patients        : [],
  aldActive       : false,
  aatActive       : false,
  selector        : false,
  mssActive       : false,
  regulationMode  : false
};

VitaleCardPatients.propTypes = {
  accessRights    : PropTypes.object.isRequired,
  showUploadForm  : PropTypes.func.isRequired,
  vitaleCardStatus: PropTypes.number,
  patients        : PropTypes.array,
  handleClick     : PropTypes.func.isRequired,
  aldActive       : PropTypes.bool,
  aatActive       : PropTypes.bool,
  selector        : PropTypes.bool,
  dataType        : PropTypes.number.isRequired,
  mssActive       : PropTypes.bool,
  regulationMode  : PropTypes.bool
};

export default VitaleCardPatients;
